import { getClientApplicationConfig } from '@hc-frontend/core-context';
import Script from 'next/script';
import React from 'react';

export default function Recaptcha() {
  const config = getClientApplicationConfig();

  return (
    <Script
      src={`https://www.google.com/recaptcha/api.js?render=${config.recaptcha.siteKey}`}
    />
  );
}
